import React, { PureComponent } from 'react';

import { trackException } from '@utils/sentry';

import { DefaultLayout as Layout } from '@layouts/DefaultLayout/DefaultLayout';

import { Container } from '@components/common/Container/Container';

type ErrorBoundaryState = { hasError: boolean };

export class ErrorBoundary extends PureComponent<unknown, ErrorBoundaryState> {
    constructor(props: unknown) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error) {
        trackException(error);
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;

        if (hasError) {
            return (
                <Layout title="Ошибка" isWithDefaultSuffix>
                    <Container>Произошла ошибка, попробуйте зайти позже</Container>
                </Layout>
            );
        }

        return children;
    }
}
